import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  required: PropTypes.bool,
  value: PropTypes.bool.isRequired,
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
};

const defaultProps = {
  required: false,
  label: '',
};

const Checkbox = props => {
  const { name, id, required, value, label, onChange, className, onBlur, ...rest } = props;

  return (
    <Fragment>
      <input
        {...rest}
        className={clsx(`h-[18px] w-[18px] appearance-none block`, className)}
        name={name}
        id={id}
        required={required}
        value={value || ''}
        label={label}
        checked={value}
        type="checkbox"
        onChange={onChange ? () => onChange({ target: { name, value: !value } }) : null}
        onBlur={onBlur}
      />

      {label}
    </Fragment>
  );
};

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;

export default Checkbox;
